import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { isNil } from 'lodash-es';

import { useAppDispatch, useAppSelector } from 'src/app/store';
import { ConfirmModal } from 'src/common/modals/ConfirmModal';

import { useTripRepository } from '../add-trip/useAddATripOnSubmit/useTripRepository';
import {
  execTripMenuAction,
  onCancelAssignTrip,
  onConfirmAssignTrip,
} from './dispatcher.slice';

export function AssignTripFlow() {
  const {
    isAssignTripModalOpen,
    tripId,
    assignmentId,
    validateAssignmentResponse,
  } = useAppSelector((state) => state.dispatcher.tripAssignmentFlow);
  const dispatch = useAppDispatch();
  const tripRepository = useTripRepository();
  return (
    <ConfirmModal
      open={isAssignTripModalOpen}
      setOpen={(isOpen) => {
        if (!isOpen) dispatch(onCancelAssignTrip());
      }}
      onCancel={() => {
        dispatch(onCancelAssignTrip());
      }}
      onConfirm={() => {
        dispatch(
          execTripMenuAction({
            action: async () => {
              const trip = await tripRepository.getTrip(tripId);
              const isUnassignedTrip = isNil(trip.assignment);
              const action = isUnassignedTrip
                ? tripRepository.assign
                : tripRepository.reassign;
              await action(tripId, assignmentId);
              await dispatch(onConfirmAssignTrip());
            },
            successMessage: 'Trip assigned',
            errorMessage: 'Error assigning trip',
          })
        );
      }}
      cancelText="Cancel"
      confirmText="Assign"
      title="Invalid Trip Assignment"
      description="Are you sure you want to assign this trip?"
      error={validateAssignmentResponse?.explanation}
      icon={<ExclamationTriangleIcon className="w-5" />}
      mode="destructive"
    />
  );
}
